import type { TimeDisplayMode } from "@/shared/components/visualization/WorkspaceCtx";

import { formatDatetimeValue } from "./formatDatetimeValue";

/**
 * Returns the display-format string to seed a logtime filter's text input
 * from its canonical nanosecond epoch value.
 *
 * Returns "" when the stage is not a logtime text input or when the
 * TimeDisplayMode has not been resolved yet (avoiding an unsafe cast at the
 * callsite). Used both for initial state and to re-seed the buffer whenever
 * the mode, earliestTime, or canonical stage value changes.
 */
export function seedLogTimeBuffer(
  value: string,
  isLogTimeText: boolean,
  mode: TimeDisplayMode | undefined,
  earliestTime: bigint | null,
): string {
  if (!isLogTimeText || mode === undefined) {
    return "";
  }
  return formatDatetimeValue(value, mode, earliestTime);
}
